import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";

const eventDispatcher = getEventDispatcher();

const MoveDownDownloadListener: EventHandler<number> = async (event: IpcMainInvokeEvent, content: number): Promise<void> => {
    await eventDispatcher.dispatch('MoveDownDownloadAction', content);
    await eventDispatcher.dispatch('ChangeDownloadPositionsAction');
}

export default MoveDownDownloadListener;